@if (showSkeleton) { @for (item of skeletonItems; track item) {
<div class="-search-card-container loader">
  <div class="-search-card-header">
    <div class="skeleton-loader skeleton-title"></div>
    <div class="skeleton-loader skeleton-tag"></div>
  </div>
  <div class="skeleton-loader skeleton-url"></div>
  <div class="skeleton-loader skeleton-excerpt"></div>
</div>
} } @else { @if (!toType || toType !== 'title') {
<app-link [to]="isInternalDocumentUri ? searchCardResponse.documentBreadcrumbs : searchCardResponse.documentURI">
  @if (searchCardResponse) {
  <div class="-search-card-container">
    <div class="-search-card-header">
      <h3 [innerHTML]="title"></h3>
      @if (searchCardResponse.docCategory) {
      <wp-chips state="neutral" contrast="contrast" [indicatorIcon]="false">
        {{ searchCardResponse.docCategory }}
      </wp-chips>
      }
    </div>
    <p class="-search-url">
      {{ searchCardResponse.documentBreadcrumbs }}
    </p>
    <p [innerHTML]="searchCardResponse.documentExcerpt"></p>
  </div>
  }
</app-link>
} @if (toType === 'title' && searchCardResponse) {
<div class="-search-card-container">
  <div class="-search-card-header">
    <app-link [to]="isInternalDocumentUri ? searchCardResponse.documentBreadcrumbs : searchCardResponse.documentURI">
      <h3 [innerHTML]="title"></h3>
    </app-link>
    @if (searchCardResponse.docCategory) {
    <wp-chips state="neutral" contrast="contrast" [indicatorIcon]="false">
      {{ searchCardResponse.docCategory }}
    </wp-chips>
    }
  </div>
  <p class="-search-url">
    {{ searchCardResponse.documentBreadcrumbs }}
  </p>
  <p [innerHTML]="searchCardResponse.documentExcerpt"></p>
</div>
} }
